import { initializeAwsWafTokenProvider } from '@order/modules-aws-waf';
import { getEnvVars } from '@order/utils';

import { getAwsWafTokenDomain } from '../getAwsWafTokenDomain';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Creates the native AWS WAF token provider for the GraphQL host.
 * Calls after the first one are ignored by the native module.
 */
export async function initializeAwsWafNativeSdk() {
  if (!APPLICATION_INTEGRATION_URL || !DOMAIN_NAME) {
    throw new Error('The AWS WAF native SDK configuration is missing');
  }

  await initializeAwsWafTokenProvider({
    applicationIntegrationUrl: APPLICATION_INTEGRATION_URL,
    domainName: DOMAIN_NAME,
  });
}

// ─── Constants ───────────────────────────────────────────────────────────────

// The challenge script is served from the protection pack (web ACL) integration URL.
const APPLICATION_INTEGRATION_URL = getEnvVars().AWS_WAF_CHALLENGE_URL?.replace(/challenge\.js$/, ''); // prettier-ignore

// Same domain as the WebView flow.
const DOMAIN_NAME = getAwsWafTokenDomain();
